import colors from '../../themes/colors';
export default function getTextColor(props) {
    var _a = props.disabled, isDisabled = _a === void 0 ? false : _a, _b = props.color, color = _b === void 0 ? 'primary' : _b, _c = props.variant, variant = _c === void 0 ? 'contained' : _c;
    var isText = variant === 'text';
    var isOutlined = variant === 'outlined';
    var isPrimary = color === 'primary';
    var isSecondary = color === 'secondary';
    var isSuccess = color === 'success';
    var isWarning = color === 'warning';
    var isError = color === 'error';
    if (isDisabled) {
        if (isOutlined) {
            if (isSuccess)
                return colors.green20;
            if (isError)
                return colors.red20;
            if (isWarning)
                return colors.yellow20;
        }
        return colors.neutral30;
    }
    if (isOutlined) {
        if (isPrimary)
            return colors.neutral100;
        if (isSecondary)
            return colors.neutral80;
        if (isSuccess)
            return colors.green80;
        if (isError)
            return colors.red80;
        if (isWarning)
            return colors.yellow70;
    }
    if (isSecondary || isWarning)
        return colors.neutral100;
    if (isText)
        return colors.bigBangBlack;
    return colors.white;
}
